export enum VisitorBookingStatus {
  Draft = 1,
  Booked = 2,
  Cancelled = 3
}